// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_translation_v} from '../lib/trans_v';
import cn from 'classnames';
import zcountry from 'zcountry';
import {use_countries} from '../ui/forms/use_countries';
import {Svg_img} from '../ui/svg_img';
import Arrow_img from '../img/homepage/how_it_works_arrow.svg';
import {Install_btn} from '../ui/install_btn';
import {Editor} from '../../../shared/editor/editor';
import styles from './vpn_access_steps.module.less';

interface i_vpn_access_steps_props {
    country: string;
}

export const Vpn_access_steps = ({country}: i_vpn_access_steps_props)=>{
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v();
    const {countries} = use_countries('fsvg_4x3', cn(styles.flag_wrap,
        theme.xs, theme.P), styles.flag_icon, null, null, true);
    const curr_country = useMemo(()=>countries.find(el=>
        el.title.toUpperCase()==(country||'')?.toUpperCase()),
    [country, countries]);
    const adj = zcountry.adj_list[curr_country?.value] ||
        zcountry.extra_adj_list[curr_country?.value] || null;
    return <div className={styles.access_wrapper}>
      <p className={cn(theme.color_n700, styles.title)}>
        {t('locations.access.title')}</p>
      <div className={styles.cards}>
        <div className={styles.card}>
          <div className={styles.card_image}>
            <Svg_img id={'homepage/how_it_works_download.svg'} />
          </div>
          <p className={cn(theme.u2, theme.color_n700)}>
            {t('locations.access.step_one')}</p>
          <span className={cn(theme.p2, theme.reg, theme.color_n600)}>
            <Install_btn keep_btn_text text={t('locations.access.download')}
              className={styles.download} no_redirect/>
            {t('locations.access.download_suffix')}
          </span>
        </div>
        <div className={styles.arrow}><Arrow_img /></div>
        <div className={styles.card}>
          <div className={styles.card_image}>
            <Svg_img id={'homepage/how_it_works_access.svg'} />
          </div>
          <p className={cn(theme.u2, theme.color_n700)}>
            {t('locations.access.step_two', {adj: adj?.adj})}</p>
          <span className={cn(theme.p2, theme.reg, theme.color_n600)}>
            {t('locations.access.country', {country: curr_country?.title})}
          </span>
        </div>
      </div>
    </div>;
};

interface i_vpn_access_steps_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Vpn_access_steps_editor = (
{value, on_change}: i_vpn_access_steps_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
